<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.business-list-page {
  height: 100vh;
  padding-top: 180px;
  overflow: scroll;
  background-image: url('https://oss.turingsenseai.com/1623912866964426136.png');
  background-size: 100% 100%;

  .search-container {
    background-image: url('https://oss.turingsenseai.com/1623913475552458502.png');
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    height: 120px;
    width: 100%;
    z-index: 999;
    .input-wrap {
      width: 702px;
      height: 72px;
      box-sizing: border-box;
      border: 4px solid #000;
      border-radius: 4px;
      background-color: #f1f1f0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 24px;
      margin: 24px auto;
      .search-input {
        flex: 1;
        margin-right: 20px;
        border: none;
        height: 64px;
        padding-left: 24px;
        background-color: #f1f1f0;
      }
      .search-icon {
        width: 36px;
        height: 36px;
        object-fit: contain;
      }
    }

  }

  .split-line {
    position: fixed;
    top: 120px;
    height: 18px;
    width: 100%;
    background-image: url('https://oss.turingsenseai.com/1623914645893707324.png');
    background-size: 100% 100%;
    z-index: 999;
  }

  .business-list {
    margin: 0 auto;
    width: 702px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .business-item {
      margin-bottom: 18px;
      width: 344px;
      height: 322px;
      box-sizing: border-box;
      border: 4px solid #000;
      border-radius: 4px;
      background-color: #f1f1f0;
      .avator {
        width: 128px;
        height: 128px;
        border: 3px solid #000;
        overflow: hidden;
        margin: 36px auto 0;
        border-radius: 50%;
        .img {
          width: 100%;
          height: 100%;
          object-fit: cover
        }
      }
      .nickname {
        margin-top: 24px;
        text-align: center;
        font-size: 28px;
        color: #000;
        font-weight: 300;
        line-height: 36px;
      }
      .msg-container {
        margin-top: 16px;
        display: flex;
        justify-content: center;
        .count-item-l, .count-item-r {
          display: flex;
          justify-content: center;
          align-items: center;
          .label {
            font-size: 26px;
            color: #758f8d;
            margin-right: 8px;
          }
          .count {
            color: #ba0000;
            font-size: 26px;
            font-weight: 700;
          }
        }
        .count-item-l {
          margin-right: 26px;
        }
      }
    }
  }
}
</style>

<template>
<div class="business-list-page">
  <div class="search-container">
    <div class="input-wrap">
      <input type="text" placeholder="搜索展位" class="search-input" v-model="searchWords"/>
      <img class="search-icon" @click="getBusinessList(true)" src="https://oss.turingsenseai.com/1623826683071669972.png"/>
    </div>
  </div>
  <div class="split-line">
  </div>
  <van-pull-refresh v-if="dataList.length > 0" v-model="refreshing" @refresh="getBusinessList(true)">
    <van-list
      v-model="loadingMore"
      :finished="finished"
      finished-text="没有更多了"
      @load="getBusinessList(false)">
      <div class="business-list">
        <div class="business-item" v-for="(business, index) in dataList" :key="index" @click="goDetail(business.businessId)">
          <div class="avator">
            <img class="img" :src="business.avatar" alt="">
          </div>
          <div class="nickname">{{business.nickName}}</div>
          <div class="msg-container">
            <div class="count-item-l">
              <div class="label">在售</div>
              <div class="count">{{business.onSaleNum}}</div>
            </div>
            <div class="count-item-r">
              <div class="label">已售</div>
              <div class="count">{{business.soldNum}}</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </van-pull-refresh>
</div>
  
</template>

<script>
import { List, PullRefresh, Popup } from 'vant';
import { fetchBusinessList } from '../../../common/api/bag-show'
export default {
  components: {
    'van-list': List,
    'van-pull-refresh': PullRefresh,
    'van-popup': Popup,
  },
  data() {
    return {
      loadingMore: false,
      finished: false,
      refreshing: false,
      pageNum: 0,
      pageSize: 20,
      searchWords: '',
      dataList: [],
      loading: false,
    }
  },
  created() {
    this.getBusinessList(true)
  },
  methods: {
    getBusinessList(reset) {
      if (reset) {
        this.pageNum = 0
        this.finished = false;
      }
      if (this.finished || this.loading) return
      this.pageNum ++ 
      this.loading = true
      fetchBusinessList({ pageNum: this.pageNum, pageSize: this.pageSize, businessName: this.searchWords })
        .then(res => {
          if (res && res.errorCode == 0) {
            this.dataList = reset ? res.businessList : [...this.dataList, ...res.businessList]
            this.finished = res.isEnd
          }
        }).finally(() => {
          this.refreshing = false;
          this.loadingMore = false;
          this.loading = false
        })
    },
    search() {

    },
    goDetail(businessId) {
      this.$router.push({ path: `/bag-show/product-list/${businessId}`})
    }
  }
}
</script>